/**
 * Also used as the Suspense fallback while translations load, so the label
 * is intentionally not translated.
 */
export function PageLoader({ className = '' }: { className?: string }) {
  return (
    <div
      role="status"
      aria-label="Loading"
      className={`flex items-center justify-center py-24 ${className}`}
    >
      <div className="border-t-brand-600 border-border size-8 animate-spin rounded-full border-2" />
      <span className="sr-only">Loading…</span>
    </div>
  )
}
